import React from 'react';
import { Link } from 'react-router-dom';

const COLUMNS = [
  {
    heading: 'Cognitics',
    links: [
      { to: '/', label: 'Home' },
      { to: '/company', label: 'Company' },
      { to: '/research', label: 'Research' },
    ],
  },
  {
    heading: 'Product',
    links: [
      { to: '/bloora', label: 'Bloora' },
      { to: '/early-access', label: 'Early Access' },
    ],
  },
  {
    heading: 'Connect',
    links: [
      { to: '/contact', label: 'Contact' },
      { href: 'mailto:cognitics.research@gmail.com', label: 'cognitics.research@gmail.com' },
      { href: 'mailto:careers@cognitics.org', label: 'Careers' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Use' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 px-6 py-16" style={{ backgroundColor: '#fbfcf3' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          {COLUMNS.map(({ heading, links }) => (
            <div key={heading}>
              <h4 className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-5">
                {heading}
              </h4>
              <ul className="space-y-3 text-sm">
                {links.map((l) =>
                  l.to ? (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        className="text-gray-700 hover:text-gray-900 transition-colors duration-300"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        className="text-gray-700 hover:text-gray-900 transition-colors duration-300 break-all"
                      >
                        {l.label}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center text-sm text-gray-500 gap-4">
          <div className="flex items-center space-x-3 font-display">
            <img src="/logo_new_v2.png" alt="Cognitics" className="h-8 w-auto" />
            <span className="tracking-wider">COGNITICS</span>
          </div>
          <p>© {new Date().getFullYear()} Cognitics Research. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
